module.exports = __webpack_public_path__ + "img/check-green.4a6da243.svg";